import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VCard,
    { attrs: { flat: "" } },
    [
      _c(
        VCardTitle,
        { staticClass: "subtitle-1 pa-0 ma-0" },
        [
          _c("span", [_vm._v(_vm._s(_vm.value.titulo))]),
          _c(VSwitch, {
            staticClass: "ml-4",
            attrs: { color: "secondary", dense: "" },
            model: {
              value: _vm.value.habilitado,
              callback: function ($$v) {
                _vm.$set(_vm.value, "habilitado", $$v)
              },
              expression: "value.habilitado",
            },
          }),
        ],
        1
      ),
      _c(
        VCardText,
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.value.habilitado,
              expression: "value.habilitado",
            },
          ],
          staticClass: "pa-0 ma-0",
        },
        [
          _c(VAutocomplete, {
            attrs: {
              items: _vm.value.lista,
              "item-text": _vm.value.itemText,
              label: _vm.value.label ? _vm.value.label : "Selecione",
              placeholder: "Digite para pesquisar...",
              "search-input": _vm.search,
              multiple: _vm.value.multiplo,
              chips: "",
              "deletable-chips": "",
              "prepend-icon": _vm.value.icone,
              "return-object": "",
              dense: "",
            },
            on: {
              "update:searchInput": function ($event) {
                _vm.search = $event
              },
              "update:search-input": function ($event) {
                _vm.search = $event
              },
              change: function ($event) {
                _vm.search = ""
              },
            },
            scopedSlots: _vm._u(
              [
                _vm.value.lista.length > 0
                  ? {
                      key: "prepend-item",
                      fn: function () {
                        return [
                          _c(
                            VListItem,
                            { on: { click: _vm.toggleItens } },
                            [
                              _c(
                                VListItemAction,
                                [
                                  _c(
                                    VIcon,
                                    {
                                      attrs: {
                                        color:
                                          _vm.value.selecionado.length > 0
                                            ? "primary"
                                            : "",
                                      },
                                    },
                                    [_vm._v(" " + _vm._s(_vm.icon) + " ")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VListItemContent,
                                [
                                  _c(VListItemTitle, [
                                    _vm._v(
                                      "Selecionar " +
                                        _vm._s(
                                          _vm.value.todas ? "Todas" : "Todos"
                                        )
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(VDivider, { staticClass: "mt-2" }),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
                {
                  key: "selection",
                  fn: function (data) {
                    return [
                      _c(
                        VChip,
                        {
                          staticClass: "chip--select-multi my-1",
                          attrs: {
                            "input-value": data.selected,
                            close: "",
                            color: "secondary",
                            small: "",
                            "text-color": "white",
                          },
                          on: {
                            "click:close": function ($event) {
                              return _vm.remove(data.item)
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(data.item[_vm.value.itemText]) + " "
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ],
              null,
              true
            ),
            model: {
              value: _vm.value.selecionado,
              callback: function ($$v) {
                _vm.$set(_vm.value, "selecionado", $$v)
              },
              expression: "value.selecionado",
            },
          }),
          _vm._t("children"),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }